import React, {useEffect} from "react";

function Popover({
                     children, show, popoverRef, onHidePopover,
                 }) {

    useEffect(() => {
        popoverRef.current?.focus();
    }, [show]);

    return (
        show ? <div className='popover-container' tabIndex={1} ref={popoverRef} onBlur={onHidePopover}>{children}</div>
            : null
    );
}

export default Popover;
